/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Empty_TitleInputs */

const en_directory_empty_title = /** @type {(inputs: Directory_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nobody offers this here yet`)
};

const pl_directory_empty_title = /** @type {(inputs: Directory_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nikt tu jeszcze tego nie oferuje`)
};

/**
* | output |
* | --- |
* | "Nobody offers this here yet" |
*
* @param {Directory_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_empty_title = /** @type {((inputs?: Directory_Empty_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Empty_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_empty_title(inputs)
	return en_directory_empty_title(inputs)
});